import { MY_VIDEO_REQUEST, MY_VIDEO_SUCCESS, MY_VIDEOS_RESET, SHOW_DELETE_MY_VIDEO } from 'pages/my-videos.page';
import { VIDEO_DELETED } from 'common/actions';
import { UPDATE_MY_VIDEO_UPLOADER, UPDATE_MY_VIDEO_RESPONSIBLE_USER } from './actions';

export const initialState = {
  video: null,
  deleteVideoId: null,
  deletedVideoId: null,
};

export const myVideosPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case MY_VIDEO_REQUEST:
      return {
        ...state,
        video: null,
      };

    case MY_VIDEO_SUCCESS:
      return {
        ...state,
        video: action.payload.video,
      };

    case UPDATE_MY_VIDEO_UPLOADER:
      return {
        ...state,
        videoUploader: action.payload.videoUploader,
      };

    case UPDATE_MY_VIDEO_RESPONSIBLE_USER:
      return {
        ...state,
        videoResponsibleUser: action.payload.responsibleUser,
      };

    case SHOW_DELETE_MY_VIDEO:
      return {
        ...state,
        deleteVideoId: action.payload.videoId,
      };

    case VIDEO_DELETED:
      return {
        ...state,
        deletedVideoId: action.payload.videoId,
      };

    case MY_VIDEOS_RESET:
      return initialState;

    default:
      return state;
  }
};
